export default __webpack_public_path__ + "static/media/plain-sticker-v.8dd5a097.png";